import * as types from '../types';
import { IDiscountsApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class DiscountsHttpApi extends HttpApi implements IDiscountsApi {
  async listDiscounts(): Promise<types.Discount[]> {
    // Backend returns every discount for the tenant in one unpaginated array.
    const response = await this.http.get<types.APIResponse<types.Discount[]>>('/discounts');
    return response.data.data;
  }

  async getDiscount(id: string): Promise<types.Discount> {
    const response = await this.http.get<types.APIResponse<types.Discount>>(`/discounts/${id}`);
    return response.data.data;
  }

  async createDiscount(data: types.CreateDiscountRequest): Promise<types.Discount> {
    const response = await this.http.post<types.APIResponse<types.Discount>>('/discounts', data);
    return response.data.data;
  }

  async updateDiscount(id: string, data: types.UpdateDiscountRequest): Promise<types.Discount> {
    const response = await this.http.patch<types.APIResponse<types.Discount>>(`/discounts/${id}`, data);
    return response.data.data;
  }

  async deleteDiscount(id: string): Promise<void> {
    await this.http.delete(`/discounts/${id}`);
  }

  async listCustomerDiscounts(customerId: string): Promise<types.Discount[]> {
    const response = await this.http.get<types.APIResponse<types.Discount[]>>(`/customers/${customerId}/discounts`);
    return response.data.data;
  }

  async attachCustomerDiscount(customerId: string, discountId: string): Promise<types.Discount[]> {
    const response = await this.http.post<types.APIResponse<types.Discount[]>>(
      `/customers/${customerId}/discounts`,
      { discountId }
    );
    return response.data.data;
  }

  async detachCustomerDiscount(customerId: string, discountId: string): Promise<types.Discount[]> {
    const response = await this.http.delete<types.APIResponse<types.Discount[]>>(
      `/customers/${customerId}/discounts/${discountId}`
    );
    return response.data.data;
  }

  async listPropertyDiscounts(propertyId: string): Promise<types.Discount[]> {
    const response = await this.http.get<types.APIResponse<types.Discount[]>>(`/properties/${propertyId}/discounts`);
    return response.data.data;
  }

  async attachPropertyDiscount(propertyId: string, discountId: string): Promise<types.Discount[]> {
    const response = await this.http.post<types.APIResponse<types.Discount[]>>(
      `/properties/${propertyId}/discounts`,
      { discountId }
    );
    return response.data.data;
  }

  async detachPropertyDiscount(propertyId: string, discountId: string): Promise<types.Discount[]> {
    const response = await this.http.delete<types.APIResponse<types.Discount[]>>(
      `/properties/${propertyId}/discounts/${discountId}`
    );
    return response.data.data;
  }
}
